import { isAddress } from 'viem';

export const isEvmAddress = (address: string): boolean => {
  return isAddress(address);
};

export const isBtcAddress = (address: string): boolean => {
  // Basic regex for Bitcoin address validation
  const btcRegex = /^[13][a-km-zA-HJ-NP-Z1-9]{25,34}$/;
  return btcRegex.test(address);
};

export const isAllowedAddress = (address: string): boolean => {
  return isEvmAddress(address) || isBtcAddress(address);
};
